// URL to the documentation page for the credit promotion
// Set this to a valid URL when documentation is available to show the "Learn More" link
export const CREDIT_PROMO_LEARN_MORE_URL: string | undefined = undefined;
